import type { GradeType } from "@/entities/user/models/enums";

export const formatPhoneNumber = (phoneNumber: string): string => {
    // 숫자만 남깁니다.
    const digitsOnly = phoneNumber.replace(/\D/g, "");

    const formattedNumber = digitsOnly.replace(/(\d{2,3})(\d{4})(\d{4})/, "$1-$2-$3");

    return formattedNumber;
};

const studentGrade: Record<GradeType, string> = {
    1: "초등학교 1학년",
    2: "초등학교 2학년",
    3: "초등학교 3학년",
    4: "초등학교 4학년",
    5: "초등학교 5학년",
    6: "초등학교 6학년",
    7: "중학교 1학년",
    8: "중학교 2학년",
    9: "중학교 3학년",
    10: "고등학교 1학년",
    11: "고등학교 2학년",
    12: "고등학교 3학년",
};

export const convertStudentGradeCode = (gradeCode: GradeType) => {
    return studentGrade[gradeCode] ? studentGrade[gradeCode] : "";
};
